import { render, staticRenderFns } from "./BikeSetup.vue?vue&type=template&id=684eac6e&"
import script from "./BikeSetup.vue?vue&type=script&lang=js&"
export * from "./BikeSetup.vue?vue&type=script&lang=js&"
import style0 from "./BikeSetup.vue?vue&type=style&index=0&id=684eac6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.10_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports